import {ThemeProvider} from "@mui/material/styles"
import "./index.css"
import theme from "./theme/Theme"
import App from "./App"
import {ConfigProvider} from "./config/ConfigProvider"
import {create} from "zustand"
import {decodeToken} from "react-jwt"
import SessionExpired from "./pages/SessionExpired/SessionExpired"
import {useTranslation} from "react-i18next"
import {useSessionStorage} from "usehooks-ts"
import {useEffect} from "react"
import "./config/i18n"
import moment from "moment"

interface TokenState {
  token: string
  setToken: (token: string) => void
}

export interface AccountPanelState {
  showAccountPanel: boolean
  setShowAccountPanel: (showAccountPanel: boolean) => void
}

export interface GuidedTourState {
  run: boolean
  completedTour: boolean
  setRun: (run: boolean) => void
  setCompletedTour: (completedTour: boolean) => void
}

export default function Root(props: any) {
  const {authStore, accountPanelStore, guidedTourStore} = props
  const useAuthStore = create<TokenState>(authStore)
  const useAccountPanelStore = create<AccountPanelState>(accountPanelStore)
  const useGuidedTourStore = create<GuidedTourState>(guidedTourStore)
  const token = useAuthStore((state) => state.token)
  const {i18n} = useTranslation()
  const [language] = useSessionStorage("language", "en")

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language)
      moment.locale(language)
    }
  }, [language])

  const user: {
    userId: string
    userName: string
    email: string
    firstname: string
    lastname: string
  } = decodeToken<any>(token)
    ? {
        userId: decodeToken<any>(token).sub,
        userName: decodeToken<any>(token).name,
        email: decodeToken<any>(token).email,
        firstname: decodeToken<any>(token).firstname,
        lastname:
          decodeToken<any>(token).lastname ||
          decodeToken<any>(token).surname ||
          "",
      }
    : {
        userId: "",
        userName: "",
        email: "",
        firstname: "",
        lastname: "",
      }

  if (token) {
    return (
      <ThemeProvider theme={theme()}>
        <ConfigProvider value={{token, user}}>
          {token === "null" ? (
            <SessionExpired />
          ) : (
            <App
              useAccountPanelStore={useAccountPanelStore}
              useGuidedTourStore={useGuidedTourStore}
            />
          )}
        </ConfigProvider>
      </ThemeProvider>
    )
  }
}
